import { render } from "./style2.vue?vue&type=template&id=06f7a662"
import script from "./style2.vue?vue&type=script&lang=js"
export * from "./style2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__